// extracted by mini-css-extract-plugin
export var avatar = "_p2-3";
export var avatarContainer = "_p2-2";
export var avatarSpacer = "_p2-5";
export var avatarSpacerContainer = "_p2-4";
export var avatarStackContainer = "_p2-1";
export var bubble = "_p2-0";
export var remainderBubble = "_p2-6";